export default {
  meta: {
    title: '点位测评',
  }
};
